import Loadable from 'UIComponents/decorators/Loadable';
const AsyncTaskDeleteModal = Loadable({
  loader: () => import( /* webpackChunkName: "task-edit-panel-modal" */'./TaskDeleteModal').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncTaskDeleteModal;